<button type="button" class="bg-primary rounded-full flex gap-2 px-4 py-2 text-sm text-white font-semibold items-center"
    (click)="onClick.emit()">
    <ng-content #name></ng-content>
    {{label}}
</button>
